import React from 'react';
import { Components } from 'botframework-webchat-component';
import ChatContent from './ChatContent';

const KWebChat = ({ directLine,isArabic }) => {

  return (
    <Components.Composer directLine={directLine}>
      <ChatContent isArabic={isArabic}/>
    </Components.Composer>
  );
};

export default KWebChat;